import React from "react";
import Button from "@amzn/meridian/button";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import { Space } from "../../space/Space";
import Row from "@amzn/meridian/row";
import LoaderBox from "../../loader/LoaderBox";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../app/store/hooks";
import { useUpdateAppealMutation } from "../../../endpoints/updateAppeal";
import { handleBackToProperty } from "../utils/utils";
import { ReviewSummaryProps } from "./types";
import { CoverPage } from "./cover-page/CoverPage";
import { SalientFacts } from "./salient-facts/SalientFacts";
import { SimpleSale } from "./review-tables/SimpleSale";
import { LeasedFeeSale } from "./review-tables/LeasedFeeSale";
import { MarketValue } from "./review-tables/MarketValue";
import { KeyIssues } from "./key-issues/KeyIssues";

export const ReviewSummary: React.FC<ReviewSummaryProps> = ({ onNext, data }) => {
    const [updateAppeal, { isLoading }] = useUpdateAppealMutation();
    const { propertyId } = useParams();
    const { alias } = useAppSelector(state => state.auth.user);
    const navigate = useNavigate();

    const handleBack = () => {
        handleBackToProperty({
            data,
            propertyId: propertyId!,
            alias,
            updateAppeal,
            navigate,
        });
    };

    if (isLoading) {
        return <LoaderBox loadingText="Loading Appeal Data..." />;
    }

    return (
        <Box>
            <Space size="l" />
            <Text type="h500">Review Summary</Text>
            <Space size="s" />
            <Text>
                Review the following information that will be included in the appeals package. To
                change any salient facts or values, go back to the property page and edit there.
            </Text>
            <Row>
                <CoverPage data={data} />
                <SalientFacts data={data} />
            </Row>
            <Space size="s" />
            <SimpleSale data={data} />
            <LeasedFeeSale data={data} />
            <MarketValue data={data} />
            <Space size="m" />
            <KeyIssues data={data} />
            <Space size="s" />
            <Row alignmentHorizontal="end" spacingInset="200">
                <Button type="link" size="large" onClick={handleBack}>
                    Back to Property
                </Button>
                <Button size="large" onClick={onNext}>
                    Next
                </Button>
            </Row>
        </Box>
    );
};
